<template>
  <div @mouseover="resetTimerSetNullCntxHelp">
    <div v-if="getTypeCntxlHelp === 1">
      <div v-if="getTabsCntxHelp.length > 1">
        <b-tabs content-class="mt-3">
          <b-tab
            v-for="tab in getTabsCntxHelp"
            :key="tab"
            :title="tab"
          >
            <div
              v-if="typeof getDataCntxlHelp[tab] !== 'undefined'"
              class="w-100 h-100"
            >
              <vue-markdown
                v-if="getDataCntxlHelp[tab] !== ''"
                :source="getDataCntxlHelp[tab]"
              />
              <div
                v-else
                class="w-100 m-2"
              >
                <h2 class="mb-4">
                  You found a new element!
                </h2>
                <h5>The component does not have documentation yet</h5>
                <p class="element-not-found">
                  But you can contribute to djuli by adding the file in the path
                  <a
                    :href="`https://github.com/djuliZP/djuli-documentation/blob/main/${getRouteCntxHelp}`"
                    target="_blank"
                  >'{{ getRouteCntxHelp }}/{{ tab }}'</a>
                </p>
                <img
                  class="center-element"
                  src="../../assets/MainMenu/djuliImage.png"
                  alt="Element not found"
                >
              </div>
            </div>
            <div
              v-else
              class="w-100 h-100 spinner-div"
            >
              <b-spinner
                variant="success"
                style="width: 4rem; height: 4rem"
                label="Large Spinner Text Centered"
              />
            </div>
          </b-tab>
        </b-tabs>
      </div>
      <div v-else>
        <vue-markdown :source="getDataCntxlHelp['Main']" />
      </div>
    </div>
    <div v-else-if="getTypeCntxlHelp === 2">
      <h2 class="mb-4">
        You found a new element!
      </h2>
      <h6>The component does not have documentation yet</h6>
      <p class="element-not-found">
        But you can contribute to djuli by adding the file in the path
        <a
          :href="`https://github.com/djuliZP/djuli-documentation/blob/main/${getRouteCntxHelp}/main.md`"
          target="_blank"
        >'{{ getRouteCntxHelp }}/main.md'</a>
      </p>
      <img
        class="center-element"
        src="../../assets/MainMenu/djuliImage.png"
        alt="Element not found"
      >
    </div>
    <div v-else>
      <p class="non-selected-text">
        Hover an element to display the information.
        <span class="inner-message">'Ctrl + click' to hold the element. Repeat or click the "Hold" icon to release.</span>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VueMarkdown from 'vue-markdown';
//Usar este link para poner los videos en linea https://morioh.com/p/487a79571ccb

export default {
  name: 'ContextualHelp',
  components: {
    VueMarkdown,
  },
  data() {
    return {
      mdValue: '',
    };
  },
  computed: {
    ...mapGetters([
      'getTypeCntxlHelp',
      'getDataCntxlHelp',
      'getRouteCntxHelp',
      'getTabsCntxHelp',
    ]),
  },
  created() {
    this.setContextualHelp(null);
  },
  methods: mapActions(['setContextualHelp','resetTimerSetNullCntxHelp']),
};
</script>

<style lang="scss" scoped>
#graphImage {
  width: 100%;
}

.non-selected-text {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.inner-message {
  font-weight: bold;
}
.spinner-div {
  text-align: center;
}

::v-deep img {
  max-width: 100%;
}
::v-deep h1 {
  color: #356635;
}
::v-deep h2 {
  color: #4f754f;
}
::v-deep h3 {
  color: #2d7028;
}
::v-deep h4 {
  color: #437d40;
}
::v-deep h5 {
  color: #378a32;
}
::v-deep h6 {
  color: #3d9636;
}
.center-element {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
  border-radius: 20px;
}
.element-not-found {
  font-size: 0.9rem;
}
</style>
